var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheckmarkCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  viewBox: "-5 -6 22 22"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 5,
  r: 10,
  fill: "none",
  stroke: "green",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "green",
  strokeWidth: 2,
  d: "m.685 4.991 3.382 3.382 7.248-7.247"
})));
export default SvgIconCheckmarkCircle;